import React from 'react';
import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";
import {RadioGroup, ReversedRadioButton} from "react-radio-buttons";

import Input from "../../core/Input";
import {calculateYearlyIncomeAction} from "../../../store/actions/calculatorActions";
import {gtm} from "../../../services/gtm";
import {assetsBaseUrl} from "../../../services/calculationsApi";
import ReactTooltip from "react-tooltip";
import {FormattedMessage, useIntl} from "react-intl";

let PER = "12";
let JVA = true;
let DMK = true;

const DefaultCalculator = ({toggleIncomeCalculator, field}) => {
    const intl = useIntl();
    const {register, handleSubmit, formState} = useForm({
        mode: 'onChange',
        defaultValues: {
            INK: null,
            ORT: null,
        }
    });

    const dispatch = useDispatch();


    const onSubmit = data => {
        data.JVA = JVA;
        data.DMK = DMK;
        data.PER = PER;
        data.INK = parseInt(data.INK);
        data.ORT = parseInt(data.ORT);

        data.UIT = 0;

        dispatch(calculateYearlyIncomeAction(data, field));

        const tagManagerArgs = {
            gtmId: 'GTM-T78CX5',
            dataLayer: {
                event: "gtm.trackEvent",
                eventCategory: "Jaarinkomen berekenen",
                eventAction: "Berekening uitvoeren",
                eventLabel: "in loondienst"
            }
        };

        gtm(tagManagerArgs);
        //TagManager.initialize(tagManagerArgs);

        toggleIncomeCalculator();
    };

    const onPERChange = (value) => {
        PER = value;
    };

    const onJVAChange = (value) => {
        JVA = parseInt(value) === 1;
    };

    const onDMKChange = (value) => {
        DMK = parseInt(value) === 1;
    };

    return (
        <div className="ct-step__income-calculator-modal-wrappers">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="ct-step__income-calculator-salaries-block">

                    <div>
                        <div className="ct-step__income-calculator-modal__subtitle">
                          <FormattedMessage id="incomeCalculator.type.employed.incomePeriod" defaultMessage="Hoe vaak ontvang jij je salaris?"/>
                        </div>
                        <RadioGroup
                            onChange={onPERChange}
                            horizontal
                            value={PER}
                            register={register}
                            className="ct-step__radio-group ct-income__radio-group"
                        >
                            <ReversedRadioButton
                                value="12"
                                rootColor="#000000"
                                pointColor="#000000"
                                iconInnerSize={18}
                                iconSize={18}
                            >
                              <FormattedMessage id="incomeCalculator.type.employed.incomePeriod.onceAMonth" defaultMessage="één keer per maand"/>
                            </ReversedRadioButton>

                            <ReversedRadioButton
                                value="13"
                                rootColor="#000000"
                                pointColor="#000000"
                                iconInnerSize={18}
                                iconSize={18}
                            >
                              <FormattedMessage id="incomeCalculator.type.employed.incomePeriod.onceEvery4Weeks" defaultMessage="één keer per 4 weken"/>
                            </ReversedRadioButton>
                        </RadioGroup>
                    </div>
                    <div>
                        <div className="ct-step__income-calculator-modal__subtitle">
                          <FormattedMessage id="incomeCalculator.type.employed.grossIncome" defaultMessage="Wat is je bruto salaris?*"/>
                        </div>

                        <Input
                            inputType="secondary"
                            type="number"
                            placeholder="2200"
                            register={register}
                            validationRules={{ required: true, min: 0 }}
                            name="INK"
                        />

                        <div className="ct-step__income-calculator-modal__subtitle">
                          <FormattedMessage id="incomeCalculator.type.employed.variableIncome" defaultMessage="Hoeveel variabel inkomen ontvang je?*"/>
                            <img className="ct-step__tool-tip"
                                 data-tip={intl.formatMessage({ id: "incomeCalculator.type.employed.variableIncome.tooltip", defaultMessage: "Een variabel inkomen is loon dat niet vast is, zoals een bonus of commissie. Denk hierbij aan een winstuitkering of prestatiebonus, maar ook aan onregelmatigheidstoeslag of uitbetaalde overwerkuren." })}
                                 src={`${assetsBaseUrl}/assets/svg/info.svg`} alt=""/>
                            <ReactTooltip place={"right"} effect={"solid"} data-iscapture='true' clickable={true} html={true} />
                        </div>

                        <Input
                            inputType="secondary"
                            placeholder="200"
                            type="number"
                            register={register}
                            validationRules={{ required: true, min: 0 }}
                            name="ORT"
                        />
                    </div>
                </div>


                <div>
                    <div className="ct-step__income-calculator-modal__subtitle">
                      <FormattedMessage id="incomeCalculator.type.employed.holidayPay" defaultMessage="Krijg je vakantiegeld?"/>
                    </div>

                    <RadioGroup onChange={onJVAChange}
                                value={(JVA) ? "1" : "0"}
                                horizontal
                                className="ct-step__radio-group ct-income__radio-group ct-income__radio-group-secondary">
                        <ReversedRadioButton
                            value="1"
                            rootColor="#000000"
                            pointColor="#000000"
                            iconInnerSize={18}
                            iconSize={18}
                        >
                            Ja
                        </ReversedRadioButton>

                        <ReversedRadioButton
                            value="0"
                            rootColor="#000000"
                            pointColor="#000000"
                            iconInnerSize={18}
                            iconSize={18}
                        >
                            Nee
                        </ReversedRadioButton>
                    </RadioGroup>
                </div>

                <div>
                    <div className="ct-step__income-calculator-modal__subtitle">
                      <FormattedMessage id="incomeCalculator.type.employed.13thMonth" defaultMessage="Krijg je een 13e maand?"/>

                    </div>

                    <RadioGroup onChange={onDMKChange} horizontal
                                value={(DMK) ? "1" : "0"}
                                className="ct-step__radio-group ct-income__radio-group ct-income__radio-group-secondary">
                        <ReversedRadioButton
                            value="1"
                            rootColor="#000000"
                            pointColor="#000000"
                            iconInnerSize={18}
                            iconSize={18}
                        >
                          <FormattedMessage id="incomeCalculator.type.employed.13thMonth.yes" defaultMessage="Ja"/>
                        </ReversedRadioButton>

                        <ReversedRadioButton
                            value="0"
                            rootColor="#000000"
                            pointColor="#000000"
                            iconInnerSize={18}
                            iconSize={18}
                        >
                          <FormattedMessage id="incomeCalculator.type.employed.13thMonth.no" defaultMessage="Nee"/>
                        </ReversedRadioButton>
                    </RadioGroup>
                </div>

                <button
                    disabled={!formState.isValid}
                    type="submit"
                    className="ct__button margin-bottom__xs-md ct-header__afspraak"
                >

                  <FormattedMessage id="incomeCalculator.calculateButton" defaultMessage="Volgende"/>
                </button>
            </form>
        </div>
    );
};

export default DefaultCalculator;
